var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full h-full w-full flex flex-col md:flex-row"},[_c('div',{staticClass:"left-lesson-bar hidden md:block"},[_vm._t("bar")],2),_c('div',{staticClass:"right-lesson-box border-l h-full"},[_vm._t("box")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }